import React from 'react';
import { Link } from 'react-router-dom';
import { FiUser, FiPhone, FiMail } from 'react-icons/fi';
import './ClientList.css';

const ClientList = ({ clients }) => {
  if (clients.length === 0) {
    return (
      <div className="empty-client-list">
        <p>No hay clientes para mostrar</p>
      </div>
    );
  }
  
  return (
    <div className="client-list">
      {clients.map(client => (
        <Link 
          key={client.id} 
          to={`/clients/${client.id}`}
          className="client-card"
        >
          <div className="client-name">{client.name}</div>
          <div className="client-info">
            <div className="client-info-item">
              <FiPhone className="client-info-icon" />
              <span>{client.phone}</span>
            </div>
            {client.email && (
              <div className="client-info-item">
                <FiMail className="client-info-icon" />
                <span>{client.email}</span>
              </div>
            )}
          </div>
        </Link>
      ))}
    </div>
  );
};

export default ClientList;